import dayjs from 'dayjs';
import pluralize from 'pluralize';
import type { TrialPhase } from './types';

/**
 * Maps days remaining in a trial to a visual phase.
 * Positive = days left, 0 and negative = trial ended (grace or hard stop).
 */
export const getTrialPhase = (daysRemaining: number): TrialPhase => {
  if (daysRemaining > 14) {
    return 'active_safe';
  }
  if (daysRemaining >= 7) {
    return 'active_warning';
  }
  if (daysRemaining >= 1) {
    return 'active_critical';
  }
  if (daysRemaining >= -7) {
    return 'grace_period';
  }
  return 'hard_stop';
};

/**
 * Formats days remaining as "X day(s)".
 */
export const formatDaysRemaining = (daysRemaining: number): string =>
  pluralize('day', daysRemaining, true);

export const getInactivityTitle = (graceEndsAt: string | null | undefined): string => {
  if (!graceEndsAt) {
    return 'System will become inactive';
  }
  const daysUntilAutoConversion = Math.max(
    0,
    Math.ceil(dayjs(graceEndsAt).diff(dayjs(), 'day', true)),
  );
  if (daysUntilAutoConversion === 0) {
    return 'System becomes inactive today';
  }
  return `System becomes inactive in ${daysUntilAutoConversion} ${pluralize(
    'day',
    daysUntilAutoConversion,
  )}`;
};
